import React from 'react';
import { Progress } from 'seduo-ui';
const Example = () => (<div>
        <div className="text-center">regular</div>
        <Progress value={50}/>
        <div className="text-center">small</div>
        <Progress value={50} className="progress--small"/>
    </div>);
export default Example;
